import List from 'containers/Companies/List';
import Edit from 'containers/Companies/Edit';
import Create from 'containers/Companies/Create';
import Show from 'containers/Companies/Show';

export default { List, Edit, Create, Show };
